import apiReq from '../commontools/api.js'
export function GetGoodsTypeByCorpid(corpid) {

	var url = '/Goods/GetGoodsTypeByCorpid/' + corpid;
	return apiReq.get(url)
}
export function AddGoodsType(info) {
	var url = '/Goods/AddGoodsType'
	var p = {
		'data': info
	}
	return apiReq.post(url, p);
}
export function EditGoodsType(info) {
	var url = '/Goods/EditGoodsType';
	var p = {
		'data': info
	}
	return apiReq.post(url, p);
}
export function GetGoodsByCorpid(corpid) {

	var url = '/Goods/GetGoodsByCorpid/' + corpid;
	return apiReq.get(url)
}
export function AddGoods(info) {
	var url = '/Goods/AddGoods'
	var p = {
		'data': info
	}
	return apiReq.post(url, p);
}
export function EditGoods(info) {
	var url = '/Goods/EditGoods';
	var p = {
		'data': info
	}
	return apiReq.post(url, p);
}
export function UploadGoodsImg(info,goodsid){
	var url='/Goods/UploadGoodsImg/'+goodsid;
	return apiReq.post(url,info);
}
export function SaveGoodsItem(goodsid,salemodulesjson){
	var url='/Goods/SaveGoodsItem/'+goodsid;
	var p = {
		data: salemodulesjson
	}
	return apiReq.post(url,p);
}
export function GetGoodsItemByGoodsid(goodsid) {

	var url = '/Goods/GetGoodsItemByGoodsid/' + goodsid;
	return apiReq.get(url)
}
export function GetGoodsItemWithFNoteByGoodsid(corpid,goodsid) {

	var url = '/Goods/GetGoodsItemWithFNoteByGoodsid/'+corpid+'/' + goodsid;
	return apiReq.get(url)
}
export function GetGoodsByCusID(cusid) {

	var url = '/Goods/GetGoodsByCusID/' + cusid;
	return apiReq.get(url)
}
export function GetGoodsByMOrderID(morderid) {

	var url = '/Goods/GetGoodsByMOrderID/' + morderid;
	return apiReq.get(url)
}

export default {
	GetGoodsTypeByCorpid,
	AddGoodsType,
	EditGoodsType,
	GetGoodsByCorpid,
	AddGoods,
	EditGoods,
	UploadGoodsImg,
	SaveGoodsItem,
	GetGoodsItemByGoodsid,
	GetGoodsByCusID,
	GetGoodsByMOrderID,
	GetGoodsItemWithFNoteByGoodsid
}
